import { orderBy } from 'lodash';
import { isInvalidSortByField } from '@modules/quantify/utils';
import { ReportDataPoint, SortBy } from '@modules/common/types';

interface SortReportDataPointsOptions {
  records: ReportDataPoint[];
  sortBy: SortBy;
}

export const sortReportDataPoints = ({
  records,
  sortBy,
}: SortReportDataPointsOptions): ReportDataPoint[] => {
  if (isInvalidSortByField(records, sortBy)) {
    return records;
  }

  return orderBy(
    records,
    (item) => item[sortBy.field] ?? item.variants?.[sortBy.field]?.value,
    [sortBy.isAsc ? 'asc' : 'desc'],
  );
};
